// extracted by mini-css-extract-plugin
export var details = "p_cx";
export var title = "p_bq";
export var main = "p_cy";
export var parameterMain = "p_cz";
export var parameterItem = "p_cB";
export var parameterItemTitle = "p_cC";
export var parameterItemContext = "p_cD";
export var descriptionItem = "p_cF";
export var image = "p_cG";